export default __webpack_public_path__ + "static/Mallory-Medium-e8c89695922c34a6cc9f2b2861fe43cd.woff";